import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const EmailLayout = lazy(() => import('../../container/conversation/overview/EmailLayout'));

function EmailRoutes() {
  const match = useRouteMatch(); 

  return (
    <Switch>

      <Route path={`${match.path}/:id`} component={EmailLayout} />
    </Switch>
  );
}

export default EmailRoutes;